<template>
  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 fixed-start"
    style="background-color: #FBFBFB;"
  >
    <sidenav-header />
    <sidenav-list />
    <!-- <sidenav-footer /> -->
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
// import SidenavFooter from "./SidenavFooter.vue";
import SidenavHeader from "./SidenavHeader.vue";
import { mapState, mapMutations } from "vuex";
import { logo } from '@/assets/img/logo.svg';

export default {
  name: "Index",
  components: {
    SidenavList,
    // SidenavFooter,
    SidenavHeader
  },
  computed: {
    ...mapState(["sidebarType", "isDarkMode", "isPinned"]),
    shareguardLogo() {
      return logo;
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),

    toggleSidebar() {
      this.navbarMinimize();
    },
  },
};
</script>
